import Folder from '../store/schema/Folder';
import getMailboxTable from './getMailboxTable';

/**
 * Selector for a particular mailbox root folder
 * @param mailboxIdentifier
 */
export default function getMailboxRootFolder(mailboxIdentifier: string): Folder {
    const mailboxTable = getMailboxTable();
    const mailbox = mailboxTable && mailboxTable.get(mailboxIdentifier);
    return mailbox && mailbox.rootFolder;
}
